import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d5cad80c&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=d5cad80c&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5cad80c')) {
      api.createRecord('d5cad80c', component.options)
    } else {
      api.reload('d5cad80c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d5cad80c&lang=pug", function () {
      api.rerender('d5cad80c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/event/trial/index.vue"
export default component.exports